/**
 * What happens once a booking is created: fire the GA4 purchase, play the site's transition
 * animation, and only then follow the thank-you redirect — so the animation is seen rather than
 * cut off by the navigation. Neither side effect may block the other, and neither may prevent
 * the redirect, hence allSettled.
 */
export interface CompleteBookingOptions {
  /** fires the GA4 purchase; resolves when sent or timed out */
  track: () => Promise<unknown>;
  /** plays the site's animation; resolves when it finishes, fails, or is capped */
  animate: () => Promise<unknown>;
  /** navigates to the thank-you page, or null to stay on the confirmation panel */
  redirect: (() => void) | null;
}

export async function completeBooking(options: CompleteBookingOptions): Promise<void> {
  await Promise.allSettled([options.track(), options.animate()]);
  options.redirect?.();
}
